import React from "react"

export default function Syringe() {
  return (
    <symbol id="svg-select-syringe" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M25.1,5.9c0-0.2-0.2-0.3-0.3-0.5l-4.5-2.6c-0.3-0.2-0.8-0.1-1,0.3c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.2,0.2,0.3,0.3,0.4L20,4.3  l-2.8,4.9l-1.9-1.1c-0.3-0.2-0.8-0.1-1,0.3c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.2,0.2,0.3,0.3,0.4l1.1,0.6l-6,10.2  c-0.1,0.2-0.1,0.4-0.1,0.5s0.2,0.3,0.3,0.4l0.8,0.4c-0.2,0.5-0.4,1.3-0.6,2.1l-0.1,0.6l-3.1,5.2l0.4,1.5l3.6-6.2l0.5-0.4  c0.7-0.6,1.3-1.1,1.6-1.5l0.8,0.4c0.3,0.2,0.8,0.1,1-0.3l6-10.2l1.1,0.6c0.3,0.2,0.8,0.1,1-0.2c0.1-0.2,0.1-0.4,0.1-0.5  c0-0.2-0.2-0.3-0.3-0.5l-1.9-1.1L23.5,6L24,6.3c0.3,0.2,0.8,0.1,1-0.2C25.1,6.3,25.1,6.1,25.1,5.9z M19.4,10.6l-1-0.6l2.8-4.9l1,0.6  L19.4,10.6z M16.7,13.3l1.7,1l-0.6,1l-1.7-1l-0.7,1.2l1.7,1l-0.6,1l-1.7-1l-0.7,1.2l1.7,1l-0.6,1l-1.7-1l-0.7,1.2l1.7,1l-0.6,1  c-0.9-0.5-1.4-0.8-2.7-1.5l5.6-9.6l2.7,1.5L19.1,13l-1.7-1L16.7,13.3z"
      />
    </symbol>
  )
}
